import React, { useState } from 'react';
import { Plus, Send, Mail, MessageSquare, Users } from 'lucide-react';

const Communications = () => {
  const [showCompose, setShowCompose] = useState(false);

  const messages = [
    { id: 1, subject: 'Welcome to Spring Semester!', recipients: 'All Parents', type: 'email', status: 'sent', sentAt: '2024-01-01' },
    { id: 2, subject: 'Class Schedule Change', recipients: 'Ballet Parents', type: 'email', status: 'sent', sentAt: '2024-01-03' },
    { id: 3, subject: 'Payment Reminder', recipients: 'Overdue Accounts', type: 'email', status: 'draft', sentAt: null },
  ];

  return (
    <div className="animate-fade-in">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Communications</h1>
          <p className="text-gray-500 mt-1">Send emails and messages to parents and staff.</p>
        </div>
        <button
          onClick={() => setShowCompose(true)}
          className="mt-4 sm:mt-0 btn-primary flex items-center space-x-2"
        >
          <Plus size={20} />
          <span>Compose</span>
        </button>
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <button className="p-4 bg-white rounded-xl shadow-sm border border-purple-100 hover:border-purple-300 hover:shadow-md transition-all text-left">
          <Mail className="text-purple-600 mb-2" size={24} />
          <p className="font-medium text-gray-900">Email All Parents</p>
        </button>
        <button className="p-4 bg-white rounded-xl shadow-sm border border-purple-100 hover:border-purple-300 hover:shadow-md transition-all text-left">
          <MessageSquare className="text-fuchsia-600 mb-2" size={24} />
          <p className="font-medium text-gray-900">Send SMS</p>
        </button>
        <button className="p-4 bg-white rounded-xl shadow-sm border border-purple-100 hover:border-purple-300 hover:shadow-md transition-all text-left">
          <Users className="text-blue-600 mb-2" size={24} />
          <p className="font-medium text-gray-900">Class Announcement</p>
        </button>
        <button className="p-4 bg-white rounded-xl shadow-sm border border-purple-100 hover:border-purple-300 hover:shadow-md transition-all text-left">
          <Send className="text-green-600 mb-2" size={24} />
          <p className="font-medium text-gray-900">Marketing Campaign</p>
        </button>
      </div>

      {/* Messages List */}
      <div className="bg-white rounded-xl shadow-sm border border-purple-100 overflow-hidden">
        <table className="w-full">
          <thead className="bg-purple-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Subject</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Recipients</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Type</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Sent</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-purple-50">
            {messages.map((message) => (
              <tr key={message.id} className="hover:bg-purple-50/50">
                <td className="px-6 py-4 font-medium text-gray-900">{message.subject}</td>
                <td className="px-6 py-4 text-gray-500">{message.recipients}</td>
                <td className="px-6 py-4">
                  <span className="badge badge-info capitalize">{message.type}</span>
                </td>
                <td className="px-6 py-4">
                  <span className={`badge ${message.status === 'sent' ? 'badge-success' : 'badge-warning'}`}>
                    {message.status}
                  </span>
                </td>
                <td className="px-6 py-4 text-gray-500">{message.sentAt || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Compose Modal */}
      {showCompose && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-2xl w-full p-6">
            <h2 className="text-xl font-bold text-gray-900 mb-4">Compose Message</h2>
            <form className="space-y-4">
              <div>
                <label className="form-label">To</label>
                <select className="form-input">
                  <option>Select recipients...</option>
                  <option>All Parents</option>
                  <option>All Employees</option>
                  <option>Ballet Parents</option>
                  <option>Gymnastics Parents</option>
                </select>
              </div>
              <div>
                <label className="form-label">Subject</label>
                <input type="text" className="form-input" placeholder="Message subject" />
              </div>
              <div>
                <label className="form-label">Message</label>
                <textarea className="form-input h-32" placeholder="Type your message..."></textarea>
              </div>
              <div className="flex items-center space-x-4">
                <label className="flex items-center">
                  <input type="radio" name="type" value="email" defaultChecked className="text-purple-600" />
                  <span className="ml-2">Email</span>
                </label>
                <label className="flex items-center">
                  <input type="radio" name="type" value="sms" className="text-purple-600" />
                  <span className="ml-2">SMS</span>
                </label>
              </div>
              <div className="flex space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowCompose(false)}
                  className="flex-1 px-4 py-2 min-h-[44px] border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-1 btn-primary min-h-[44px]"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowCompose(false);
                  }}
                >
                  Send
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Communications;
